var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildseaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#3659B2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#paint0_radial_1523_922)",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0217 18.2942C26.0349 18.292 27.669 16.6592 27.669 14.6471C27.669 12.629 26.0354 10.9954 24.0217 11C22.0052 10.9957 20.3724 12.629 20.3738 14.6474C20.3724 16.6595 22.0052 18.292 24.0217 18.2942Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0215 25.9267H20.1543V23.1283L17.2097 26.1019C15.8754 27.4362 14.0697 25.728 15.408 24.3883L20.2855 19.4961C20.6841 19.1062 21.1174 18.8565 21.8093 18.8508H24.0215H26.1893C26.8728 18.8565 27.3359 19.0992 27.7418 19.4961L32.6782 24.4466C33.9482 25.7114 32.0933 27.4356 30.8767 26.1458L27.8441 23.1139V25.9265L24.0215 25.9267ZM28.9907 16.0852L15.963 28.0755L17.0329 29.2379L30.0612 17.2478L28.9907 16.0852Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8249 29.207C26.4823 27.0073 21.3551 27.0219 17.0329 29.2363C16.8192 28.819 16.6053 28.4023 16.3914 27.9856C21.1141 25.5659 26.7155 25.5499 31.4596 27.9525C31.2481 28.3708 31.0367 28.7889 30.8249 29.207Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9162 28.2478L23.0547 30.386L20.9314 32.509L23.1136 34.6925C24.3963 35.9774 22.6214 37.8187 21.2967 36.4942L17.8396 32.906C17.1019 32.1465 16.8972 30.752 17.6935 29.9619C17.6935 29.959 18.2249 29.4245 18.7943 28.8524C18.7943 28.8524 19.8203 28.4503 20.9162 28.2478Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2051 28.8522C29.7742 29.424 30.3059 29.9587 30.3059 29.9617C31.1017 30.7518 30.8978 32.1465 30.1597 32.9057L26.7025 36.494C25.3779 37.8188 23.6028 35.9775 24.8858 34.6923L27.068 32.5088L24.9447 30.3858L27.0829 28.2476C28.1788 28.4504 29.2051 28.8522 29.2051 28.8522Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0442 30.1016C15.9111 30.2179 15.7091 30.2041 15.593 30.0704L14.9738 29.3603C14.8577 29.2274 14.8715 29.0254 15.0047 28.9091L15.6123 28.3796C15.7454 28.2632 15.7883 28.266 15.9046 28.3996L16.6719 29.2797C16.7879 29.4129 16.785 29.4557 16.6521 29.5718L16.0442 30.1016ZM16.2831 29.3982C16.3533 29.3361 16.3606 29.2301 16.2994 29.1602L15.9729 28.7852C15.9116 28.715 15.8048 28.7076 15.7346 28.7686L15.4591 29.0091C15.3889 29.0702 15.3813 29.177 15.4428 29.2472L15.7693 29.6219C15.8306 29.6924 15.9374 29.6995 16.0073 29.6385L16.2831 29.3982Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1523_922",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5 9.5) rotate(128.904) scale(36.6231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7295EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467061,
    stopColor: "#3659B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildseaticon);
export default __webpack_public_path__ + "static/media/childseaticon.dc15f1b1e8be9464520d2bf18ad977e5.svg";
export { ForwardRef as ReactComponent };